import { ColProps, Form, Radio, Select } from "antd";
import { Control, Controller, FieldValues, Path } from "react-hook-form";

interface Props<TSchema extends FieldValues> {
  name: Path<TSchema>; // Allow only field names (string) that are listed into the Schema
  disabled?: boolean;
  errorMessage?: string;
  control: Control<TSchema>;
  options: { value: string; label: string }[];
  labelCol?: ColProps | undefined;
  wrapperCol?: ColProps | undefined;
}

export default function FieldRadioButton<TSchema extends FieldValues>(
  props: Props<TSchema>,
) {
  const {
    name,
    errorMessage,
    control,
    options,
    disabled,
    labelCol,
    wrapperCol,
  } = props;
  return (
    <Form.Item
      validateStatus={errorMessage ? "error" : ""}
      help={errorMessage || null}
      labelCol={labelCol}
      wrapperCol={wrapperCol}
    >
      <Controller
        control={control}
        name={name}
        render={({ field }) => (
          <Radio.Group
            {...field}
            options={options}
            value={field.value || null}
            optionType="button"
            buttonStyle="solid"
            disabled={disabled}
          />
        )}
      />
    </Form.Item>
  );
}
